/* ============================================================
   Sparring de Infecciosas · Mirmedic
   DATOS. Todo lo editable está aquí: rasgos del rival, intro
   y los 50 conceptos. La lógica no toca este archivo.
   ============================================================ */
window.MM_SPARRING_INF = window.MM_SPARRING_INF || {};

window.MM_SPARRING_INF.config = {
  brand: 'Mirmedic',
  subject: 'Infecciosas',
  exam: 'MIR 2027',
  roundSize: 10,
  /* Enlace del botón final para pedir el correo (formulario de Shopify,
     página de suscripción, etc.). Si se deja vacío, el bloque no se muestra. */
  emailUrl: '',
  emailTitle: '¿Quieres el Sparring de las demás asignaturas?',
  emailText: 'Déjanos tu correo y te avisamos cuando salga cada uno.',
  emailButton: 'Dejar mi correo',
  /* CTA suave hacia el producto. Deja productUrl vacío para ocultarlo. */
  productUrl: 'https://mirmedic.com/products/resumenes-mir',
  /* Franja superior: desactivada (deja topText vacío para que no aparezca) */
  examDate: '2027-01-23',
  topBadge: '',
  topText: '',
  topButton: '',
  productButton: 'Entrar en Resúmenes MIR Activos',
  productPills: ['Todas las asignaturas', 'Recuerdo activo en cada tema', 'Claves MIR integradas', 'Acceso hasta el MIR 2028'],
  productFoot: 'Estudias el tema una vez. Lo repasas todas las que hagan falta.',
  /* Asignaturas del abanico del cierre (la de este Sparring aparece sellada) */
  fanSubjects: ['Infecciosas', 'Cardiología', 'Digestivo', 'Neurología', 'Nefrología'],
  storageKey: 'mm_spar_inf_v1',
  storageHours: 48
};

/* ---------- Los 6 rasgos del rival (leyenda de todo el widget) ---------- */
window.MM_SPARRING_INF.traits = {
  actual: {
    seal: 'Actual',
    name: 'Quiere parecer actual',
    desc: 'Lo primero que se pregunta al sentarse a redactar es qué ha cambiado desde que él estudiaba. Una guía nueva o una alerta epidemiológica española pesan más que su frecuencia histórica.'
  },
  justo: {
    seal: 'Guardia',
    name: 'Pregunta lo de guardia',
    desc: 'Quiere ser justo, no exótico. Pregunta lo que un R1 tiene que resolver en su primera noche: sepsis, meningitis, antibiótico empírico, aislamiento. Las rarezas las guarda para el distractor.'
  },
  proa: {
    seal: 'PROA',
    name: 'Castiga el reflejo',
    desc: 'Vive obsesionado con el uso prudente de antibióticos. Le encanta la pregunta cuya respuesta correcta es no tratar, desescalar o pasar a vía oral. Es la pregunta con la que se siente útil.'
  },
  inmuno: {
    seal: 'Inmuno',
    name: 'Su consulta es el inmunodeprimido',
    desc: 'Trasplantados, neutropénicos, pacientes con biológicos. Es su trabajo diario y su tema favorito. En el MIR 2026 cayeron Nocardia, citomegalovirus y candidemia en ese contexto.'
  },
  espana: {
    seal: 'España',
    name: 'Orgullo español',
    desc: 'Brucelosis, fiebre botonosa, leishmania, Nilo Occidental, Crimea-Congo. Es su forma de decir que esto no sale de un manual americano. Y le permite meter un dato epidemiológico local.'
  },
  micro: {
    seal: 'Micro',
    name: 'Lleva un microbiólogo dentro',
    desc: 'Le gusta la tabla de antibiograma, el mecanismo de resistencia y la prueba diagnóstica con su limitación. En el MIR 2026 puso un antibiograma completo en una tabla. Ese formato le funcionó.'
  }
};

/* ---------- Intro jugable: adivina al rival ---------- */
/* Cada paso: 'guess' (elige qué pregunta escribiría) o 'proof' (rasgo con prueba real del MIR 2026) */
window.MM_SPARRING_INF.intro = [
  {
    type: 'guess',
    trait: 'actual',
    question: '¿Cuál de estas dos preguntas escribiría?',
    opts: [
      'Paciente con prótesis valvular que va a una extracción dental. ¿Profilaxis según la guía europea vigente?',
      'Clasifique las rickettsias según su grupo antigénico.'
    ],
    ok: 0,
    reveal: 'Ha elegido la guía europea de 2023 antes que la taxonomía. Cuando algo ha cambiado hace poco, lo pregunta casi seguro.'
  },
  {
    type: 'proof',
    trait: 'justo',
    proof: 'MIR 2026, pregunta 37',
    proofText: 'Manejo inicial del shock séptico: si no hay vía central y no se alcanza el objetivo, se pueden empezar los vasopresores por una vía periférica. Nada raro. Lo que se decide en una guardia real.'
  },
  {
    type: 'guess',
    trait: 'proa',
    question: '¿Cuál de estas dos preguntas escribiría?',
    opts: [
      'Anciana con sonda vesical, orina turbia y urocultivo positivo, sin fiebre ni síntomas. ¿Qué haces?',
      'Indique la dosis de gentamicina en mg/kg/día en la pielonefritis.'
    ],
    ok: 0,
    reveal: 'La respuesta correcta a la primera es no tratar. Esa es su pregunta favorita: la que castiga al que pone antibiótico por reflejo.'
  },
  {
    type: 'proof',
    trait: 'inmuno',
    proof: 'MIR 2026, preguntas 36 y 38',
    proofText: 'Nocardia farcinica en una paciente con quimioterapia intubada en UCI. Y el diagnóstico de la enfermedad por citomegalovirus en trasplante. Dos preguntas seguidas en el paciente que él ve cada día.'
  },
  {
    type: 'guess',
    trait: 'espana',
    question: '¿Cuál de estas dos preguntas escribiría?',
    opts: [
      'Fiebre, exantema y una escara negra en el muslo tras una excursión con el perro en agosto por Extremadura.',
      'Tratamiento de la enfermedad de Lyme en un excursionista de Connecticut.'
    ],
    ok: 0,
    reveal: 'Fiebre botonosa mediterránea. Le encanta poner en el examen la infectología que se ve en España y no en un manual traducido.'
  },
  {
    type: 'proof',
    trait: 'micro',
    proof: 'MIR 2026, pregunta 35',
    proofText: 'Una tabla de antibiograma completa, con las CMI, y la pregunta de qué hacer con una paciente en shock. Había que reconocer la BLEE y cambiar a carbapenem. Ese formato ha funcionado y volverá.'
  }
];

/* Hueco del examen anterior (se muestra tras los 6 rasgos) */
window.MM_SPARRING_INF.gap = {
  title: 'Y una pista más: lo que no cayó',
  text: 'En el MIR 2026 no hubo pregunta directa de VIH, ni de endocarditis, ni de tratamiento de tuberculosis, ni de malaria, ni de sífilis, ni de zoonosis. Ese hueco es la mitad de este entrenamiento.'
};

/* ---------- Bloques temáticos ---------- */
window.MM_SPARRING_INF.blocks = {
  nov: 'Lo que acaba de cambiar',
  endo: 'Endocarditis',
  proa: 'Antibioterapia y PROA',
  urg: 'Urgencias de guardia',
  vih: 'VIH',
  tb: 'Tuberculosis',
  zoo: 'Zoonosis e importadas',
  hosp: 'ITS y hospital'
};

/* ---------- Los 50 conceptos ----------
   fmt: duelo | vf | hueco | caso | antibiograma | prediccion
   why: por qué lo preguntaría (una línea, en voz del rival)
   exp: lo que hay que quedarse (2-4 líneas)
--------------------------------------------------------------- */
window.MM_SPARRING_INF.concepts = [

  /* =================== ASALTO 1 =================== */
  {
    id: 1, block: 'nov', trait: 'actual', fmt: 'vf',
    title: 'Sarampión: España pierde la eliminación',
    q: 'Desde enero de 2026, España vuelve a considerarse un país con transmisión endémica de sarampión.',
    ok: true,
    why: 'Es la noticia de salud pública del año y le permite preguntar clínica, aislamiento y profilaxis en una sola pregunta.',
    exp: 'El Comité Regional de Verificación de la OMS lo comunicó el 27 de enero de 2026: no se pudo descartar una cadena de transmisión de más de 12 meses. Casos confirmados: 227 en 2024 y 397 en 2025, muchos importados de Marruecos y Rumanía. Recuerda: aislamiento aéreo, manchas de Koplik, exantema cefalocaudal. Profilaxis postexposición en susceptibles: vacuna en las primeras 72 horas o inmunoglobulina hasta el 6.º día (embarazadas, lactantes, inmunodeprimidos).'
  },
  {
    id: 2, block: 'endo', trait: 'proa', fmt: 'caso',
    title: 'Profilaxis de endocarditis',
    q: 'Varón de 62 años portador de prótesis valvular aórtica mecánica, sin alergias, que va a someterse a una extracción dental. ¿Cuál es la actitud correcta?',
    opts: [
      'Amoxicilina 2 g por vía oral 30-60 minutos antes del procedimiento',
      'No está indicada la profilaxis en ningún procedimiento dental',
      'Cefazolina intravenosa durante 48 horas',
      'Clindamicina 600 mg por vía oral antes del procedimiento'
    ],
    ok: 0,
    why: 'Con esta pregunta castiga a quien estudió con material antiguo: la profilaxis se ha ido restringiendo edición tras edición.',
    exp: 'Solo en pacientes de alto riesgo (prótesis o material valvular, endocarditis previa, cardiopatía congénita cianótica no corregida o corregida con material) y solo en procedimientos dentales con manipulación gingival, periapical o perforación de la mucosa oral. Amoxicilina 2 g dosis única. En alérgicos, la guía ESC 2023 ya no recomienda clindamicina: alternativas cefalexina, azitromicina o doxiciclina.'
  },
  {
    id: 3, block: 'urg', trait: 'justo', fmt: 'duelo',
    title: 'Listeria: quién y con qué',
    q: 'Meningitis aguda en una mujer de 68 años. Junto a la cefalosporina de tercera generación, ¿cuál de estos dos fármacos hay que añadir para cubrir <em>Listeria</em>?',
    opts: ['Ampicilina', 'Vancomicina'],
    ok: 0,
    why: 'Es la pregunta de guardia por excelencia: el empírico de la meningitis cambia con la edad del paciente.',
    exp: '<em>Listeria monocytogenes</em> es intrínsecamente resistente a las cefalosporinas. Se cubre con ampicilina (a menudo con gentamicina en las formas graves) y con cotrimoxazol en alérgicos. Hay que añadirla en mayores de 50 años, inmunodeprimidos, embarazadas, alcohólicos y neonatos. La vancomicina se añade por otro motivo: el neumococo con sensibilidad disminuida a cefalosporinas.'
  },
  {
    id: 4, block: 'nov', trait: 'actual', fmt: 'hueco',
    title: 'Lenacapavir como PrEP',
    pre: 'El lenacapavir como profilaxis preexposición frente al VIH se administra por vía subcutánea cada',
    post: '.',
    chips: ['mes', '2 meses', '6 meses', '12 meses'],
    ok: 2,
    why: 'Novedad limpia, con ensayos espectaculares detrás y sin ambigüedad en la respuesta. El redactor sueña con preguntas así.',
    exp: 'Inhibidor de la cápside del VIH-1. Aprobado por la Comisión Europea como PrEP en agosto de 2025 tras los ensayos PURPOSE 1 (mujeres cisgénero en África: cero infecciones) y PURPOSE 2. Dos inyecciones al año, con una carga oral de dos días al inicio. Las otras opciones de PrEP: tenofovir/emtricitabina oral diaria y cabotegravir inyectable cada 2 meses.'
  },
  {
    id: 5, block: 'tb', trait: 'actual', fmt: 'duelo',
    title: 'Latente: pautas cortas',
    q: 'Infección tuberculosa latente en un adulto sano. ¿Cuál de estas dos pautas es hoy la preferida?',
    opts: ['Rifampicina 4 meses (4R)', 'Isoniazida 9 meses (9H)'],
    ok: 0,
    why: 'Muchos temarios siguen diciendo 9 meses de isoniazida. Es un cambio de guía perfecto para discriminar.',
    exp: 'Las pautas cortas son ahora las preferidas: rifampicina diaria 4 meses (4R) o isoniazida más rifapentina semanal 12 semanas (3HP). Misma eficacia, menos hepatotoxicidad y mucha más adherencia que 6-9 meses de isoniazida, que queda como alternativa. Ojo a las interacciones de rifampicina (anticonceptivos, antirretrovirales, anticoagulantes).'
  },
  {
    id: 6, block: 'zoo', trait: 'espana', fmt: 'caso',
    title: 'Brucelosis',
    q: 'Ganadero de 45 años de Extremadura con fiebre vespertina de tres semanas, sudoración profusa, artralgias y dolor sacroilíaco. Hemocultivos en curso y serología rosa de Bengala positiva. ¿Tratamiento de elección?',
    opts: [
      'Doxiciclina 6 semanas más un aminoglucósido (estreptomicina o gentamicina) las primeras 2-3 semanas',
      'Amoxicilina-clavulánico 10 días',
      'Azitromicina 3 días',
      'Ceftriaxona intravenosa 2 semanas'
    ],
    ok: 0,
    why: 'La zoonosis más española del temario. Lleva tiempo sin caer y el redactor la considera cultura general del infectólogo.',
    exp: 'Fiebre ondulante, sudoración, hepatoesplenomegalia, leucopenia. Complicación más frecuente: la osteoarticular (sacroileítis, espondilitis). La más grave: endocarditis. Pautas: doxiciclina más aminoglucósido (menos recaídas) o doxiciclina más rifampicina 6 semanas. Avisa al laboratorio: <em>Brucella</em> es una de las causas más frecuentes de infección adquirida en el laboratorio.'
  },
  {
    id: 7, block: 'proa', trait: 'micro', fmt: 'vf',
    title: 'Daptomicina y el pulmón',
    q: 'La daptomicina es una buena opción para tratar la neumonía por <em>Staphylococcus aureus</em> resistente a meticilina.',
    ok: false,
    why: 'Un detalle de farmacología que el especialista considera lo mínimo exigible. Y es un distractor perfecto.',
    exp: 'La daptomicina se inactiva con el surfactante pulmonar: nunca en neumonía. Para el SARM pulmonar, linezolid o vancomicina. La daptomicina brilla en bacteriemia y endocarditis derecha. Otros dos clásicos: linezolid y síndrome serotoninérgico con antidepresivos, y la nefrotoxicidad de la vancomicina, mayor si se combina con piperacilina-tazobactam.'
  },
  {
    id: 8, block: 'vih', trait: 'inmuno', fmt: 'duelo',
    title: 'Toxoplasmosis o linfoma',
    q: 'Paciente con VIH y 40 CD4, lesión cerebral única periventricular con realce, serología de toxoplasma negativa y PCR de virus de Epstein-Barr positiva en líquido cefalorraquídeo. ¿Qué es más probable?',
    opts: ['Linfoma primario del sistema nervioso central', 'Toxoplasmosis cerebral'],
    ok: 0,
    why: 'Es el diferencial que más le gusta del VIH avanzado: cada dato del caso inclina la balanza.',
    exp: 'Toxoplasmosis: lesiones múltiples en ganglios basales, IgG positiva, responde en 10-14 días a sulfadiazina más pirimetamina (o cotrimoxazol). Linfoma: lesión única periventricular, VEB en líquido cefalorraquídeo, captación en SPECT con talio, sin respuesta al tratamiento empírico. Si en dos semanas no mejora, se biopsia.'
  },
  {
    id: 9, block: 'nov', trait: 'espana', fmt: 'caso',
    title: 'Virus del Nilo Occidental',
    q: 'Varón de 74 años de Coria del Río (Sevilla), a finales de agosto, con fiebre, cefalea, confusión y debilidad flácida aguda en una extremidad. Líquido cefalorraquídeo con pleocitosis linfocitaria. ¿Diagnóstico más probable?',
    opts: [
      'Meningoencefalitis por virus del Nilo Occidental',
      'Encefalitis por virus herpes simple',
      'Meningitis por <em>Listeria</em>',
      'Fiebre botonosa mediterránea'
    ],
    ok: 0,
    why: 'Brote grande en Andalucía en 2024, Extremadura en 2025 y repunte andaluz en 2026. Es la zoonosis emergente que más le gusta contar.',
    exp: 'Flavivirus transmitido por mosquitos <em>Culex</em>; las aves son el reservorio y el humano un hospedador final. El 80% son asintomáticos y menos del 1% desarrollan enfermedad neuroinvasiva, sobre todo mayores de 60 años. Pista muy típica: parálisis flácida aguda tipo poliomielitis. Diagnóstico con IgM en líquido cefalorraquídeo o suero (la PCR es poco sensible). No hay tratamiento específico ni vacuna humana.'
  },
  {
    id: 10, block: 'hosp', trait: 'proa', fmt: 'hueco',
    title: 'Clostridioides difficile',
    pre: 'En un primer episodio de infección por <em>C. difficile</em> no fulminante, el tratamiento de elección según las guías actuales es',
    post: '.',
    chips: ['metronidazol oral', 'fidaxomicina', 'vancomicina intravenosa', 'rifaximina'],
    ok: 1,
    why: 'Ya lo usó como distractor en la pregunta 30 del MIR 2026. Lo tiene en la cabeza, y las guías han cambiado la primera opción.',
    exp: 'Fidaxomicina 200 mg cada 12 horas 10 días, por menos recurrencias. Alternativa: vancomicina oral. Metronidazol solo si no hay otra opción y el cuadro es leve. La vancomicina intravenosa no sirve: no llega a la luz del colon. En la forma fulminante, vancomicina oral a dosis altas más metronidazol intravenoso. A partir de la segunda recurrencia, trasplante de microbiota fecal.'
  },

  /* =================== ASALTO 2 =================== */
  {
    id: 11, block: 'endo', trait: 'actual', fmt: 'vf',
    title: 'Criterios de Duke-ISCVID 2023',
    q: 'En los criterios diagnósticos de endocarditis de 2023, la captación patológica en la válvula en el PET-TC con 18F-FDG se considera un criterio mayor.',
    ok: true,
    why: 'Un cambio de criterios diagnósticos es pregunta casi obligada. Y la endocarditis no cayó en 2026.',
    exp: 'Los criterios de Duke actualizados (ISCVID 2023 y guía ESC 2023) incorporan como criterio mayor de imagen el PET-TC con FDG y el TC cardíaco, además del ecocardiograma. También amplían los microorganismos típicos (por ejemplo <em>Enterococcus faecalis</em> y todos los estreptococos salvo neumococo y piógenes) y añaden <em>Coxiella</em>, <em>Bartonella</em> y <em>Tropheryma whipplei</em> como criterio mayor microbiológico.'
  },
  {
    id: 12, block: 'proa', trait: 'proa', fmt: 'vf',
    title: 'Desetiquetado de alergia a penicilina',
    q: 'La reactividad cruzada real entre penicilina y cefalosporinas de tercera generación ronda el 10-15%, por lo que en un alérgico etiquetado conviene evitarlas.',
    ok: false,
    why: 'Tema estrella de los programas PROA y todavía poco preguntado. Le permite lucirse.',
    exp: 'La reactividad cruzada real es del 1-2% y depende de la cadena lateral, no del anillo betalactámico. Alrededor del 10% de la población lleva la etiqueta, pero menos del 10% de ellos son alérgicos de verdad: más del 90% tolera la penicilina al estudiarse. La etiqueta se asocia a más vancomicina, más quinolonas, más <em>C. difficile</em> y más SARM. En bajo riesgo se puede desetiquetar con una prueba de provocación oral directa.'
  },
  {
    id: 13, block: 'urg', trait: 'justo', fmt: 'duelo',
    title: 'Encefalitis herpética',
    q: 'Sospecha clínica de encefalitis herpética y PCR de virus herpes simple negativa en líquido cefalorraquídeo obtenido a las 24 horas del inicio. ¿Qué haces?',
    opts: ['Mantener el aciclovir y repetir la PCR a los 3-7 días', 'Suspender el aciclovir'],
    ok: 0,
    why: 'Le gusta el matiz que separa al que sabe el protocolo del que sabe por qué existe el protocolo.',
    exp: 'La PCR puede ser falsamente negativa en las primeras 72 horas. Ante la sospecha (fiebre, alteración de conducta, crisis, afectación temporal en la RM) se inicia aciclovir 10 mg/kg cada 8 horas por vía intravenosa sin esperar y se mantiene 14-21 días. Si la evolución no cuadra, piensa en encefalitis autoinmune anti-NMDA, sobre todo en mujeres jóvenes.'
  },
  {
    id: 14, block: 'zoo', trait: 'justo', fmt: 'caso',
    title: 'Malaria grave',
    q: 'Viajero de 34 años que vuelve de Guinea Ecuatorial sin profilaxis. Fiebre, obnubilación, creatinina de 3 mg/dl y parasitemia del 6% por <em>Plasmodium falciparum</em>. ¿Tratamiento de elección?',
    opts: [
      'Artesunato intravenoso',
      'Quinina intravenosa más doxiciclina',
      'Atovacuona-proguanil por vía oral',
      'Cloroquina por vía oral'
    ],
    ok: 0,
    why: 'La malaria no cayó en 2026. Y el error clásico del viajero con fiebre al que nadie pregunta por el viaje le sigue pareciendo formativo.',
    exp: 'Criterios de gravedad: alteración de conciencia, convulsiones, insuficiencia renal, acidosis, hipoglucemia, anemia grave, distrés respiratorio, parasitemia elevada. El artesunato intravenoso ha desplazado a la quinina; se completa después con una pauta oral. En la no complicada: artemeter-lumefantrina o atovacuona-proguanil. Diagnóstico con gota gruesa y test antigénico. Vigila la hemoglobina cuatro semanas: hemólisis tardía tras artesunato.'
  },
  {
    id: 15, block: 'vih', trait: 'inmuno', fmt: 'hueco',
    title: 'Pneumocystis y corticoides',
    pre: 'En la neumonía por <em>Pneumocystis jirovecii</em> se añaden corticoides cuando la PaO₂ basal es menor de',
    post: 'mmHg.',
    chips: ['90', '80', '70', '60'],
    ok: 2,
    why: 'Es su umbral favorito: un número que cambia el tratamiento y que casi nadie recuerda bien.',
    exp: 'PaO₂ menor de 70 mmHg o gradiente alveolo-arterial de 35 o más. Prednisona 40 mg cada 12 horas 5 días, 40 mg al día 5 días y 20 mg al día 11 días, empezando con el cotrimoxazol (21 días). Claves del cuadro: disnea progresiva, LDH alta, infiltrado intersticial bilateral, neumotórax. Profilaxis con cotrimoxazol si CD4 por debajo de 200.'
  },
  {
    id: 16, block: 'tb', trait: 'proa', fmt: 'vf',
    title: 'IGRA antes de biológicos',
    q: 'El IGRA, a diferencia del Mantoux, no da falsos positivos por la vacuna BCG.',
    ok: true,
    why: 'El cribado antes de anti-TNF es un escenario que ve cada semana en su consulta. Y le deja preguntar la prueba con su limitación.',
    exp: 'Los IGRA usan antígenos (ESAT-6 y CFP-10) ausentes en la BCG y en casi todas las micobacterias no tuberculosas (excepciones: <em>M. kansasii</em>, <em>M. marinum</em>, <em>M. szulgai</em>). Ni el IGRA ni el Mantoux distinguen infección latente de enfermedad activa. Antes de un anti-TNF: cribar, descartar enfermedad activa y tratar la latente, idealmente al menos un mes antes de iniciar el biológico.'
  },
  {
    id: 17, block: 'zoo', trait: 'espana', fmt: 'caso',
    title: 'Fiebre botonosa mediterránea',
    q: 'Agosto. Varón de 50 años con perro, fiebre alta, cefalea y exantema maculopapular que afecta a palmas y plantas. En el muslo, una lesión negra costrosa indolora. ¿Diagnóstico?',
    opts: [
      'Fiebre botonosa mediterránea',
      'Leishmaniasis cutánea',
      'Sífilis secundaria',
      'Sarna noruega'
    ],
    ok: 0,
    why: 'La rickettsiosis más de aquí que existe. Garrapata del perro, verano y mancha negra: es su caso clínico ideal.',
    exp: '<em>Rickettsia conorii</em>, transmitida por la garrapata del perro <em>Rhipicephalus sanguineus</em>. La escara de inoculación (mancha negra) es la clave. Diagnóstico serológico retrospectivo: se trata sin esperar. Doxiciclina 100 mg cada 12 horas, también en niños (pauta corta). La afectación palmoplantar comparte diferencial con sífilis secundaria y con la enfermedad mano-pie-boca.'
  },
  {
    id: 18, block: 'proa', trait: 'proa', fmt: 'caso',
    title: 'Bacteriuria asintomática',
    q: 'Mujer de 82 años institucionalizada, con sonda vesical permanente. Orina turbia y maloliente, afebril, sin dolor ni síntomas. Urocultivo con <em>E. coli</em> 10⁵ UFC/ml. ¿Actitud?',
    opts: [
      'No tratar',
      'Fosfomicina trometamol dosis única',
      'Ciprofloxacino 7 días',
      'Retirar la sonda e iniciar ceftriaxona'
    ],
    ok: 0,
    why: 'Su pregunta trampa favorita. La orina turbia y el olor no son criterios de nada, y lo sabe.',
    exp: 'Solo se trata la bacteriuria asintomática en dos situaciones: embarazo y antes de un procedimiento urológico con sangrado de mucosa. Ni en ancianos, ni en diabéticos, ni en portadores de sonda, ni en trasplantados renales pasado el primer mes. Tratar aumenta resistencias y <em>C. difficile</em> sin beneficio. Solo hay infección si hay síntomas.'
  },
  {
    id: 19, block: 'hosp', trait: 'justo', fmt: 'vf',
    title: 'Sífilis: penicilina benzatina',
    q: 'En la sífilis latente tardía o de duración desconocida basta con una dosis única de penicilina G benzatina 2,4 millones de unidades por vía intramuscular.',
    ok: false,
    why: 'La incidencia está en máximos históricos en España y lleva demasiado sin caer. Sabe que es una pregunta que renta.',
    exp: 'La dosis única vale solo para la primaria, la secundaria y la latente precoz (menos de un año). Latente tardía o de duración desconocida: tres dosis semanales. Neurosífilis y sífilis ocular u ótica: penicilina G sódica intravenosa 10-14 días. Avisa de la reacción de Jarisch-Herxheimer. Seguimiento con prueba no treponémica (RPR o VDRL): el título debe caer cuatro veces en 6-12 meses. Las treponémicas quedan positivas de por vida y no sirven para el seguimiento.'
  },
  {
    id: 20, block: 'proa', trait: 'micro', fmt: 'antibiograma',
    title: 'Carbapenemasas',
    q: 'Bacteriemia por <em>Klebsiella pneumoniae</em> en un paciente de UCI. Este es el antibiograma. ¿Qué mecanismo sospechas y qué eliges?',
    rows: [
      ['Piperacilina-tazobactam', '> 64', 'R'],
      ['Cefotaxima', '> 32', 'R'],
      ['Ceftazidima', '> 32', 'R'],
      ['Ertapenem', '> 2', 'R'],
      ['Meropenem', '> 16', 'R'],
      ['Ceftazidima-avibactam', '2', 'S'],
      ['Amikacina', '4', 'S'],
      ['Colistina', '0,5', 'S']
    ],
    opts: [
      'BLEE: tratar con meropenem',
      'Carbapenemasa tipo OXA-48: tratar con ceftazidima-avibactam',
      'Metalo-betalactamasa: tratar con ceftazidima-avibactam',
      'AmpC: tratar con cefepime'
    ],
    ok: 1,
    why: 'El antibiograma con BLEE ya cayó en 2026. La rotación natural es subir un escalón hasta la carbapenemasa más española: OXA-48.',
    exp: 'Resistencia a carbapenémicos con sensibilidad a ceftazidima-avibactam apunta a una carbapenemasa de clase A (KPC) o D (OXA-48), la más frecuente en España. Las metalo-betalactamasas (NDM, VIM) no se inhiben con avibactam: ahí van aztreonam más ceftazidima-avibactam o cefiderocol, que es activo frente a todas las clases. Con una BLEE aislada, el meropenem seguiría siendo sensible.'
  },

  /* =================== ASALTO 3 =================== */
  {
    id: 21, block: 'urg', trait: 'justo', fmt: 'duelo',
    title: 'Dexametasona en la meningitis',
    q: 'Meningitis bacteriana aguda en un adulto. ¿Cuándo se administra la dexametasona?',
    opts: ['Antes o junto con la primera dosis de antibiótico', 'Cuando el cultivo confirme neumococo'],
    ok: 0,
    why: 'Separa al que ha hecho guardias del que no. Y le permite meter en la misma pregunta cuándo hacer TC antes de la punción.',
    exp: 'Dexametasona 10 mg cada 6 horas 4 días, antes o con el antibiótico: reduce mortalidad y secuelas auditivas, sobre todo en neumococo. Se retira si el germen es otro. TC antes de la punción si hay focalidad, crisis reciente, inmunodepresión, papiledema o disminución del nivel de conciencia, pero el antibiótico no se retrasa por la prueba de imagen.'
  },
  {
    id: 22, block: 'endo', trait: 'justo', fmt: 'caso',
    title: 'Cirugía precoz en endocarditis',
    q: 'Endocarditis mitral por <em>S. aureus</em> con insuficiencia mitral grave, insuficiencia cardíaca, vegetación de 15 mm y dos episodios embólicos pese al tratamiento. ¿Actitud?',
    opts: [
      'Cirugía precoz',
      'Completar 6 semanas de antibiótico y reevaluar',
      'Iniciar anticoagulación para prevenir nuevos embolismos',
      'Cambiar el antibiótico a daptomicina'
    ],
    ok: 0,
    why: 'Tres indicaciones que se aprenden de memoria y se preguntan en caso clínico. Es infalible.',
    exp: 'Las tres indicaciones de cirugía: insuficiencia cardíaca por disfunción valvular, infección no controlada (absceso, fístula, hemocultivos persistentes, microorganismos resistentes u hongos) y prevención de embolismos (vegetación mayor de 10 mm con embolismo o con otra indicación quirúrgica, o vegetaciones muy grandes). La anticoagulación no previene embolismos sépticos y aumenta el riesgo de hemorragia cerebral.'
  },
  {
    id: 23, block: 'vih', trait: 'actual', fmt: 'vf',
    title: 'Tratamiento antirretroviral: cuándo empezar',
    q: 'El tratamiento antirretroviral debe ofrecerse a toda persona con VIH desde el diagnóstico, con independencia de los CD4, y puede iniciarse el mismo día.',
    ok: true,
    why: 'El VIH no tuvo pregunta directa en 2026. Y el cambio de paradigma frente al antiguo esperar a los CD4 es puro terreno suyo.',
    exp: 'Desde el ensayo START, tratar a todos y cuanto antes. Regímenes de elección: bictegravir/tenofovir alafenamida/emtricitabina, o dolutegravir con dos análogos, o la biterapia dolutegravir/lamivudina si la carga viral es menor de 500.000 y no hay hepatitis B. Antes de abacavir, HLA-B*5701. Las excepciones al inicio inmediato: meningitis criptocócica y tuberculosis meníngea.'
  },
  {
    id: 24, block: 'urg', trait: 'justo', fmt: 'duelo',
    title: 'Fascitis necrosante',
    q: 'Celulitis con dolor desproporcionado a la exploración, crepitación y deterioro sistémico rápido. ¿Cuál es el paso decisivo?',
    opts: ['Exploración quirúrgica urgente', 'Resonancia magnética para confirmar'],
    ok: 0,
    why: 'La lección que quiere que se lleve el R1: el diagnóstico es quirúrgico y ninguna imagen debe retrasarlo.',
    exp: 'Desbridamiento quirúrgico precoz y agresivo; la imagen orienta pero nunca retrasa la cirugía. Antibiótico amplio (piperacilina-tazobactam o carbapenem, más cobertura de SARM) y clindamicina, que inhibe la síntesis de toxina y funciona con inóculo alto (efecto Eagle). Tipo II: <em>Streptococcus pyogenes</em>, a veces con síndrome de shock tóxico. La escala LRINEC orienta, pero no descarta.'
  },
  {
    id: 25, block: 'tb', trait: 'actual', fmt: 'hueco',
    title: 'BPaLM en tuberculosis multirresistente',
    pre: 'El esquema BPaLM de 6 meses para la tuberculosis multirresistente incluye bedaquilina, pretomanid, linezolid y',
    post: '.',
    chips: ['moxifloxacino', 'amikacina', 'etambutol', 'rifampicina'],
    ok: 0,
    why: 'El cambio más espectacular de la especialidad en una década: de 18-20 meses con inyectables a 6 meses por vía oral.',
    exp: 'Recomendado por la OMS desde 2022 para TB resistente a rifampicina o multirresistente (resistente a isoniazida y rifampicina). Si hay resistencia a fluoroquinolonas, BPaL sin moxifloxacino. Vigila el intervalo QT (bedaquilina y moxifloxacino) y la toxicidad del linezolid (mielosupresión, neuropatía). Sustituye a los regímenes largos con inyectables.'
  },
  {
    id: 26, block: 'zoo', trait: 'espana', fmt: 'caso',
    title: 'Leishmaniasis visceral',
    q: 'Paciente de Madrid en tratamiento con un anti-TNF, con fiebre de dos meses, esplenomegalia masiva, pancitopenia e hipergammaglobulinemia policlonal. ¿Diagnóstico más probable?',
    opts: [
      'Leishmaniasis visceral',
      'Linfoma esplénico',
      'Brucelosis',
      'Endocarditis subaguda'
    ],
    ok: 0,
    why: 'Tiene brote urbano español propio (Fuenlabrada) y aparece en su consulta de inmunodeprimidos. Doble motivo.',
    exp: '<em>Leishmania infantum</em>, transmitida por <em>Phlebotomus</em>; el perro es el reservorio clásico y las liebres lo fueron en el brote de Fuenlabrada (2009-2012). Diagnóstico: amastigotes en aspirado de médula ósea, serología (rK39) y PCR. Tratamiento: anfotericina B liposomal. En VIH, dosis total mayor y profilaxis secundaria hasta recuperar los CD4.'
  },
  {
    id: 27, block: 'proa', trait: 'proa', fmt: 'vf',
    title: 'Duraciones cortas',
    q: 'En la neumonía adquirida en la comunidad hay que completar siempre 10 días de antibiótico, aunque el paciente esté afebril y estable desde el tercer día.',
    ok: false,
    why: 'Menos es más es la doctrina de su especialidad ahora mismo. Le gusta desmontar el mito de completar diez días.',
    exp: 'Mínimo 5 días y al menos 48 horas afebril y estable. Bacteriemia por bacilos gramnegativos no complicada: 7 días. Pielonefritis: 7 días con fluoroquinolona (10-14 con betalactámico). Celulitis no complicada: 5-6 días. Las excepciones largas siguen siendo las de siempre: endocarditis, osteomielitis, absceso no drenado, <em>S. aureus</em> en sangre.'
  },
  {
    id: 28, block: 'urg', trait: 'inmuno', fmt: 'caso',
    title: 'Neutropenia febril',
    q: 'Paciente con leucemia aguda en el día 7 de quimioterapia, 200 neutrófilos, fiebre de 38,5 °C, hemodinámicamente estable, sin foco. ¿Tratamiento empírico inicial?',
    opts: [
      'Monoterapia con un betalactámico antipseudomónico (cefepime, piperacilina-tazobactam o meropenem)',
      'Vancomicina más amikacina',
      'Amoxicilina-clavulánico por vía oral',
      'Anfotericina B liposomal'
    ],
    ok: 0,
    why: 'Territorio natural del consultor de Infecciosas. Y una pregunta que se puede escalar con un solo detalle.',
    exp: 'Fiebre de 38,3 °C o 38 °C mantenida una hora con menos de 500 neutrófilos. Alto riesgo: monoterapia antipseudomónica en la primera hora, hemocultivos de catéter y periféricos. Vancomicina solo si inestabilidad, infección de catéter o piel, o colonización por SARM. Bajo riesgo (MASCC de 21 o más): amoxicilina-clavulánico más ciprofloxacino oral y manejo ambulatorio. Antifúngico empírico si la fiebre persiste 4-7 días.'
  },
  {
    id: 29, block: 'hosp', trait: 'micro', fmt: 'vf',
    title: 'Gonococo: adiós a la doble terapia',
    q: 'En la infección gonocócica no complicada sigue siendo obligatorio asociar azitromicina a la ceftriaxona en todos los casos.',
    ok: false,
    why: 'Las resistencias son su obsesión, y el gonococo es el ejemplo donde el tratamiento ha cambiado varias veces.',
    exp: 'Ceftriaxona intramuscular en dosis única (500 mg a 1 g según guía). La azitromicina se retiró del régimen dual por resistencias a macrólidos. Si no se ha descartado <em>Chlamydia</em>, se añade doxiciclina 7 días. Hay cepas con resistencia extendida a cefalosporinas: pide cultivo con antibiograma en fallos y cribado de las demás ITS y VIH.'
  },
  {
    id: 30, block: 'zoo', trait: 'espana', fmt: 'vf',
    title: 'Crimea-Congo en España',
    q: 'En España se han diagnosticado casos autóctonos de fiebre hemorrágica de Crimea-Congo transmitidos por garrapatas del género <em>Hyalomma</em>.',
    ok: true,
    why: 'Le fascina que exista en España. Y le permite preguntar aislamiento estricto y riesgo para el personal sanitario.',
    exp: 'Primer caso autóctono en 2016 (Ávila), con transmisión nosocomial a una enfermera; después casos en Castilla y León, Extremadura, Madrid y otras zonas. Nairovirus. Fiebre, trombopenia y hemorragias; letalidad del 10-40%. Aislamiento estricto por riesgo de contagio con fluidos. Ribavirina en uso compasivo. Prevención: protección frente a garrapatas.'
  },

  /* =================== ASALTO 4 =================== */
  {
    id: 31, block: 'zoo', trait: 'inmuno', fmt: 'caso',
    title: 'Strongyloides antes de inmunosuprimir',
    q: 'Paciente boliviano que va a recibir corticoides a dosis altas y rituximab. Eosinofilia leve en la analítica. ¿Qué haces antes de empezar?',
    opts: [
      'Serología de <em>Strongyloides</em> y tratar con ivermectina antes de la inmunosupresión',
      'Nada, la eosinofilia leve no requiere estudio',
      'Albendazol empírico 3 días',
      'Esperar a que aparezcan síntomas digestivos'
    ],
    ok: 0,
    why: 'Es un concepto de seguridad del paciente, y eso le da peso extra en su cabeza.',
    exp: 'Con corticoides, HTLV-1 o trasplante puede producirse el síndrome de hiperinfección: larvas diseminadas, sepsis por gramnegativos y meningitis, con alta mortalidad. El parásito persiste décadas por autoinfección. Cribado en cualquier persona de zona endémica antes de corticoides, biológicos o trasplante. Ivermectina 200 µg/kg/día dos días.'
  },
  {
    id: 32, block: 'hosp', trait: 'inmuno', fmt: 'duelo',
    title: 'Reactivación del VHB',
    q: 'Paciente con HBsAg negativo y anti-HBc positivo que va a recibir rituximab. ¿Qué haces?',
    opts: ['Profilaxis con entecavir o tenofovir', 'Solo vigilar el ADN del VHB'],
    ok: 0,
    why: 'Un error aquí es una hepatitis fulminante. Es de las preguntas que considera obligatorias para cualquier médico que use inmunosupresores.',
    exp: 'Con anti-CD20 (rituximab) o trasplante de progenitores, el riesgo de reactivación es alto incluso con anti-HBc aislado: profilaxis antiviral, mantenida 12-18 meses tras la última dosis. Con HBsAg positivo, profilaxis siempre, con cualquier inmunosupresor. Con anti-TNF en anti-HBc aislado el riesgo es moderado y se acepta la vigilancia estrecha.'
  },
  {
    id: 33, block: 'vih', trait: 'inmuno', fmt: 'duelo',
    title: 'Cuándo iniciar el TAR con criptococo',
    q: 'Meningitis criptocócica en un paciente con VIH recién diagnosticado. ¿Cuándo empiezas el tratamiento antirretroviral?',
    opts: ['Diferido 4-6 semanas', 'En la primera semana'],
    ok: 0,
    why: 'La excepción a la regla de tratar cuanto antes. Es su pregunta de matiz por excelencia.',
    exp: 'En la meningitis criptocócica el inicio precoz aumentó la mortalidad (ensayo COAT) por el síndrome inflamatorio de reconstitución inmune: se difiere 4-6 semanas. Lo mismo en tuberculosis meníngea. En cambio, en tuberculosis no meníngea con menos de 50 CD4 se inicia en 2 semanas, y en <em>Pneumocystis</em> también en 2 semanas.'
  },
  {
    id: 34, block: 'vih', trait: 'inmuno', fmt: 'vf',
    title: 'Criptococo: la presión de apertura',
    q: 'En la meningitis criptocócica con presión de apertura elevada se recomienda acetazolamida y evitar las punciones lumbares repetidas.',
    ok: false,
    why: 'Es el dato que casi nadie recuerda y que reduce mortalidad. Justo lo que le gusta preguntar.',
    exp: 'La hipertensión intracraneal es la principal causa de muerte precoz: punciones evacuadoras repetidas hasta controlarla. La acetazolamida no ayuda y se asoció a más efectos adversos. Inducción con anfotericina B liposomal más flucitosina, consolidación con fluconazol 800 mg 8 semanas, mantenimiento con 200 mg hasta CD4 por encima de 100 con carga viral indetectable. Cribado con antígeno criptocócico en suero si CD4 menor de 100.'
  },
  {
    id: 35, block: 'endo', trait: 'actual', fmt: 'vf',
    title: 'Terapia oral parcial (POET)',
    q: 'En la endocarditis izquierda estabilizada por estreptococos, enterococos, <em>S. aureus</em> o estafilococos coagulasa negativos es posible completar el tratamiento por vía oral tras al menos 10 días de antibiótico intravenoso.',
    ok: true,
    why: 'Le encanta citar un ensayo con nombre, y este desmonta un dogma. Va incorporado a la guía europea de 2023.',
    exp: 'Ensayo POET (2019), recogido en la ESC 2023: pacientes estables, sin abscesos ni complicaciones, con ecocardiograma transesofágico de control antes del cambio, y dos fármacos orales de alta biodisponibilidad. El equivalente osteoarticular es el ensayo OVIVA: la vía oral no fue inferior a la intravenosa en infección ósea y articular.'
  },
  {
    id: 36, block: 'zoo', trait: 'micro', fmt: 'hueco',
    title: 'Fiebre Q crónica',
    pre: 'La endocarditis con hemocultivos negativos por <em>Coxiella burnetii</em> se diagnostica por serología: IgG frente a antígenos de fase',
    post: 'con título de 1:800 o superior.',
    chips: ['I', 'II', 'III', 'IV'],
    ok: 0,
    why: 'Zoonosis española con serología de interpretación exigente. Es microbiología pura, que es su terreno.',
    exp: 'Fase II en la infección aguda (neumonía, hepatitis con granulomas en anillo); fase I en la crónica (endocarditis, infección vascular). Contacto con ganado y partos de animales. Aguda: doxiciclina 14 días. Crónica: doxiciclina más hidroxicloroquina 18-24 meses. <em>Coxiella</em> es ahora criterio mayor microbiológico de endocarditis.'
  },
  {
    id: 37, block: 'hosp', trait: 'justo', fmt: 'caso',
    title: 'Profilaxis de contactos',
    q: 'Conviviente de un caso de enfermedad meningocócica invasiva confirmada. ¿Qué le indicas?',
    opts: [
      'Quimioprofilaxis lo antes posible: rifampicina 2 días, ciprofloxacino dosis única o ceftriaxona intramuscular',
      'No precisa nada si está asintomático',
      'Solo vacunación frente al serogrupo implicado',
      'Amoxicilina 7 días'
    ],
    ok: 0,
    why: 'El aislamiento por gotas ya cayó en 2026. La rotación es la profilaxis de contactos, que es lo siguiente que se pregunta.',
    exp: 'Contactos estrechos (convivientes, guardería, exposición a secreciones): profilaxis en las primeras 24 horas, útil hasta 10-14 días. También al propio paciente si no se trató con ceftriaxona, para erradicar el estado de portador. El caso se aísla por gotas 24 horas de tratamiento. Compara: tosferina, azitromicina a contactos; sarampión, vacuna en 72 horas o inmunoglobulina; varicela, vacuna en 3-5 días.'
  },
  {
    id: 38, block: 'zoo', trait: 'espana', fmt: 'vf',
    title: 'Chagas en gestantes',
    q: 'En España se recomienda el cribado serológico de enfermedad de Chagas en las embarazadas procedentes de Latinoamérica continental.',
    ok: true,
    why: 'Salud pública y parasitología en una sola pregunta, con protocolo español propio.',
    exp: '<em>Trypanosoma cruzi</em>. En Europa no hay transmisión vectorial: importa la vertical (en torno al 5%) y la transfusional, con cribado obligatorio en donantes. En el hijo de madre positiva, parasitología o PCR al nacer y serología a partir de los 9 meses. Benznidazol en niños y en la madre tras la lactancia; contraindicado en el embarazo. Fase crónica: miocardiopatía, megacolon, megaesófago.'
  },
  {
    id: 39, block: 'urg', trait: 'justo', fmt: 'vf',
    title: 'Hidrocortisona en el shock séptico',
    q: 'En el shock séptico los corticoides están contraindicados, aunque se necesiten dosis crecientes de noradrenalina.',
    ok: false,
    why: 'En 2026 preguntó los vasopresores por vía periférica. Los corticoides y el tipo de cristaloide son lo que le queda por preguntar.',
    exp: 'Surviving Sepsis 2021: hidrocortisona si la noradrenalina llega a 0,25 µg/kg/min o más durante al menos 4 horas. Cristaloides, preferiblemente balanceados, 30 ml/kg en la reanimación inicial, guiados por lactato. Antibiótico en la primera hora si hay shock. Vasopresina como segundo vasopresor. Objetivo de presión arterial media de 65 mmHg o más.'
  },
  {
    id: 40, block: 'hosp', trait: 'micro', fmt: 'duelo',
    title: 'S. aureus y el catéter',
    q: 'Bacteriemia por <em>Staphylococcus aureus</em> en un portador de catéter venoso central. ¿Retiras el catéter?',
    opts: ['Siempre', 'Solo si persiste la fiebre a las 72 horas'],
    ok: 0,
    why: 'Consultoría diaria. Y le permite encadenar la duración del tratamiento y el ecocardiograma obligado.',
    exp: 'Retirar siempre con <em>S. aureus</em>, <em>Pseudomonas</em>, <em>Candida</em>, micobacterias, sepsis grave o tromboflebitis. Con estafilococos coagulasa negativos se puede intentar conservar con sellado. Diagnóstico: hemocultivos simultáneos con diferencia de tiempo de positividad de 2 horas o más. Toda bacteriemia por <em>S. aureus</em> exige ecocardiograma, control de hemocultivos y al menos 14 días desde el primer hemocultivo negativo si no es complicada.'
  },

  /* =================== ASALTO 5 =================== */
  {
    id: 41, block: 'nov', trait: 'actual', fmt: 'hueco',
    title: 'Calendario común 2026',
    pre: 'En el calendario común de vacunación 2026, la vacuna frente al virus del papiloma humano a los 12 años se administra en',
    post: '.',
    chips: ['1 dosis', '2 dosis', '3 dosis', 'ninguna, solo en chicas'],
    ok: 0,
    why: 'El calendario cambia cada diciembre y él lo revisa antes de redactar. Cualquiera de sus novedades es pregunta directa.',
    exp: 'Calendario aprobado el 12 de diciembre de 2025: VPH en dosis única a los 12 años en niños y niñas, con captación hasta los 18. Herpes zóster recombinante a los 65 años (dos dosis) y captación de cohortes hasta los 80. Gripe desde los 60 y neumococo desde los 65. Nirsevimab a todos los lactantes en su primera temporada de VRS. Ojo: algunas comunidades, como Madrid, han sustituido MenC por MenACWY a los 12 meses, pero el calendario común mantiene MenC.'
  },
  {
    id: 42, block: 'tb', trait: 'actual', fmt: 'vf',
    title: 'Tuberculosis sensible en 4 meses',
    q: 'Existe una pauta de 4 meses con rifapentina y moxifloxacino para la tuberculosis pulmonar sensible, con eficacia no inferior a la pauta estándar de 6 meses.',
    ok: true,
    why: 'El tratamiento de la tuberculosis no cayó en 2026, y esta es la forma más actual de preguntarlo.',
    exp: 'Ensayo Study 31/A5349 (2021): 2 meses de isoniazida, rifapentina, pirazinamida y moxifloxacino seguidos de 2 meses de isoniazida, rifapentina y moxifloxacino. La OMS la admite como opción; la pauta estándar sigue siendo 2HRZE/4HR. En niños con tuberculosis no grave, 4 meses (ensayo SHINE). Toxicidades: neuropatía por isoniazida (piridoxina), neuritis óptica por etambutol, hiperuricemia por pirazinamida.'
  },
  {
    id: 43, block: 'nov', trait: 'micro', fmt: 'vf',
    title: 'Candida auris',
    q: '<em>Candida auris</em> se identifica sin dificultad con los métodos bioquímicos convencionales y suele ser sensible a fluconazol.',
    ok: false,
    why: 'Alerta nacional, brotes en UCI españolas y un problema de identificación en el laboratorio: tiene todo lo que le gusta.',
    exp: 'Se identifica mal con métodos bioquímicos convencionales: hace falta MALDI-TOF o secuenciación. Alrededor del 90% son resistentes a fluconazol, con resistencia variable a anfotericina y a equinocandinas. Tratamiento: equinocandina. Cribado de contactos con frotis de axila e ingle. Para cualquier candidemia: equinocandina, retirar el catéter, fondo de ojo, hemocultivos de control y 14 días desde el primer negativo.'
  },
  {
    id: 44, block: 'nov', trait: 'actual', fmt: 'hueco',
    title: 'Doxi-PEP',
    pre: 'La doxi-PEP consiste en tomar doxiciclina 200 mg en las',
    post: 'horas siguientes a una relación sexual sin preservativo.',
    chips: ['24', '72', '120', '168'],
    ok: 1,
    why: 'La novedad de ITS del bienio, con ensayo en la revista más citada y debate sobre resistencias. Irresistible.',
    exp: 'Ensayo DoxyPEP (2023): reduce sífilis y clamidia en torno a dos tercios, y gonococo bastante menos por resistencia a tetraciclinas. Indicado en hombres que tienen sexo con hombres y mujeres trans con ITS bacteriana previa o en PrEP. No se ha demostrado en mujeres cisgénero. No protege del VIH. Preocupación: resistencias en gonococo y en flora comensal.'
  },
  {
    id: 45, block: 'nov', trait: 'actual', fmt: 'vf',
    title: 'Mpox clado I',
    q: 'El clado Ib de mpox motivó una emergencia de salud pública de importancia internacional en 2024, y la vacuna MVA-BN se recomienda a los grupos de riesgo.',
    ok: true,
    why: 'Dos emergencias internacionales en tres años. Le sirve para preguntar clínica, aislamiento y vacuna con un caso sencillo.',
    exp: 'El brote de 2022 fue por clado IIb, con transmisión sexual en hombres que tienen sexo con hombres. El clado Ib surgió en 2024 en la República Democrática del Congo y países vecinos, más grave y con transmisión doméstica y en niños. Clínica: pródromo, adenopatías y lesiones vesículo-pustulosas en el mismo estadio (a diferencia de la varicela). Diagnóstico por PCR. Aislamiento de contacto y gotas.'
  },
  {
    id: 46, block: 'tb', trait: 'justo', fmt: 'vf',
    title: 'Corticoides en la tuberculosis meníngea',
    q: 'En la meningitis tuberculosa los corticoides están contraindicados porque favorecen la diseminación del bacilo.',
    ok: false,
    why: 'Las formas extrapulmonares le permiten preguntar tuberculosis sin repetir la pauta de siempre.',
    exp: 'Dexametasona durante 6-8 semanas reduce la mortalidad; también se usan en la pericarditis tuberculosa. La meníngea se trata 12 meses. Pleural: exudado linfocitario con ADA elevada, baciloscopia poco rentable, biopsia pleural con granulomas. Miliar: patrón micronodular difuso y tubérculos coroideos en el fondo de ojo.'
  },
  {
    id: 47, block: 'proa', trait: 'proa', fmt: 'caso',
    title: 'Cuándo no cubrir SARM ni Pseudomonas',
    q: 'Varón de 45 años sano, sin ingresos ni antibióticos en el último año y sin aislamientos previos, con neumonía adquirida en la comunidad que ingresa en planta. ¿Tratamiento empírico?',
    opts: [
      'Ceftriaxona más azitromicina (o levofloxacino en monoterapia)',
      'Piperacilina-tazobactam más vancomicina',
      'Meropenem más linezolid',
      'Cefepime más levofloxacino'
    ],
    ok: 0,
    why: 'Quiere castigar el reflejo de poner meropenem y vancomicina a todo el mundo. Es su cruzada personal.',
    exp: 'Se cubren SARM o <em>Pseudomonas</em> solo con aislamiento previo o con hospitalización reciente con antibióticos intravenosos, según la epidemiología local. Se toman cultivos y se desescala. En la neumonía comunitaria grave, betalactámico más macrólido. El concepto de neumonía asociada a cuidados sanitarios como justificación de amplio espectro está abandonado.'
  },
  {
    id: 48, block: 'urg', trait: 'inmuno', fmt: 'duelo',
    title: 'Aspergilosis invasiva',
    q: 'Paciente neutropénico con nódulos pulmonares con signo del halo y galactomanano sérico positivo. ¿Tratamiento de elección?',
    opts: ['Voriconazol o isavuconazol', 'Fluconazol'],
    ok: 0,
    why: 'El hongo del neutropénico es su pan de cada día. Y el fluconazol es un distractor que siempre funciona.',
    exp: 'Fluconazol no cubre <em>Aspergillus</em>. Elección: voriconazol o isavuconazol; anfotericina B liposomal como alternativa. Halo precoz, media luna aérea al recuperar los neutrófilos. Profilaxis con posaconazol en leucemia aguda y trasplante. El galactomanano es específico de <em>Aspergillus</em>; el beta-D-glucano detecta varios hongos pero no mucorales ni <em>Cryptococcus</em>.'
  },
  {
    id: 49, block: 'hosp', trait: 'justo', fmt: 'vf',
    title: 'Prótesis articular: DAIR y rifampicina',
    q: 'En la infección aguda de prótesis articular con implante estable se puede desbridar conservando el implante, añadiendo rifampicina si el microorganismo es un estafilococo.',
    ok: true,
    why: 'Biofilm, rifampicina y decisión quirúrgica en una sola pregunta. Es un tema de consultoría que domina.',
    exp: 'DAIR (desbridamiento, antibióticos y retención del implante) si los síntomas llevan menos de 3-4 semanas, el implante está estable y las partes blandas están sanas. Rifampicina por su acción sobre el biofilm, nunca en monoterapia. En la infección crónica, recambio en uno o dos tiempos. Diagnóstico: líquido sinovial, varias biopsias periprotésicas y sonicación del implante.'
  },
  {
    id: 50, block: 'vih', trait: 'justo', fmt: 'caso',
    title: 'Profilaxis postexposición al VIH',
    q: 'Enfermera con pinchazo profundo con aguja hueca de un paciente con VIH y carga viral detectable. Han pasado dos horas. ¿Actitud?',
    opts: [
      'Iniciar profilaxis postexposición cuanto antes: tenofovir/emtricitabina más dolutegravir o raltegravir durante 28 días',
      'Esperar la serología del paciente antes de decidir',
      'Lavado de la herida y serología a los 3 meses, sin fármacos',
      'Zidovudina en monoterapia 4 semanas'
    ],
    ok: 0,
    why: 'El pinchazo del residente es la pregunta que se hace a sí mismo. Ocupacional y no ocupacional, misma pauta.',
    exp: 'Ventana máxima de 72 horas, idealmente en las primeras 2. Tres fármacos 28 días. No está indicada si la fuente tiene carga viral indetectable mantenida. Seguimiento con test de cuarta generación a las 6 semanas y a los 3 meses. Valora también hepatitis B (vacuna o inmunoglobulina) y hepatitis C (PCR de seguimiento).'
  }
];


/* ============================================================
   Sparring de Infecciosas · Mirmedic — lógica
   Prefijos: clases mm-spar-*, funciones mirmedic_spar_*
   Sin localStorage como base: solo red de seguridad 48 h.
   ============================================================ */
(function () {
  'use strict';

  var D = window.MM_SPARRING_INF;
  if (!D || !D.concepts) return;
  var CFG = D.config, TR = D.traits, INTRO = D.intro, K = D.concepts, BL = D.blocks;
  var ROUND = CFG.roundSize || 10;
  var ROUNDS = Math.ceil(K.length / ROUND);

  var root = document.querySelector('[data-mm-spar]');
  if (!root) return;

  /* ---------- utilidades ---------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function btn(cls, html, onClick) {
    var b = el('button', cls, html);
    b.type = 'button';
    if (onClick) b.addEventListener('click', onClick);
    return b;
  }
  function imp(node, prop, val) { node.style.setProperty(prop, val, 'important'); }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function shuffled(n) {
    var a = []; for (var i = 0; i < n; i++) a.push(i);
    for (var k = n - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var t = a[k]; a[k] = a[j]; a[j] = t; }
    return a;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function stripTags(s) { return String(s).replace(/<[^>]+>/g, ''); }

  var reduced = false;
  try { reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- estado ---------- */
  var S = {
    phase: 'cover',     // cover | intro | legend | play | round | final
    introStep: 0,
    idx: 0,             // índice del concepto actual
    results: {},        // id -> true/false
    answered: false     // el concepto actual ya tiene respuesta
  };

  /* ---------- guardado (solo red de seguridad) ---------- */
  function store() {
    var s = null;
    try { s = window.sessionStorage; } catch (e) {}
    if (!s) { try { s = window.localStorage; } catch (e) {} }
    return s;
  }
  function save() {
    try {
      var st = store(); if (!st) return;
      st.setItem(CFG.storageKey, JSON.stringify({ v: 1, t: Date.now(), idx: S.idx, results: S.results, phase: S.phase }));
    } catch (e) {}
  }
  function load() {
    try {
      var st = store(); if (!st) return null;
      var raw = st.getItem(CFG.storageKey); if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || o.v !== 1) return null;
      if (Date.now() - o.t > (CFG.storageHours || 48) * 3600 * 1000) return null;
      if (o.phase === 'final' || !o.results || Object.keys(o.results).length === 0) return null;
      return o;
    } catch (e) { return null; }
  }
  function clear() {
    try { var st = store(); if (st) st.removeItem(CFG.storageKey); } catch (e) {}
  }

  /* ---------- estructura base ---------- */
  root.innerHTML = '';
  var head = el('div', 'mm-spar__head');
  var headL = el('div', 'mm-spar__head-left');
  headL.appendChild(el('div', 'mm-spar__brand', esc(CFG.brand)));
  headL.appendChild(el('h2', 'mm-spar__title', 'El Sparring <span>de ' + esc(CFG.subject) + '</span>'));
  headL.appendChild(el('p', 'mm-spar__head-sub', K.length + ' conceptos con más papeletas de caer en el ' + esc(CFG.exam) + ', en ' + ROUNDS + ' asaltos.'));
  /* Ring: los dos boxeadores */
  var ringEl = el('div', 'mm-spar__ring');
  ringEl.setAttribute('aria-hidden', 'true');
  ringEl.innerHTML = "<svg viewBox='0 0 210 104' xmlns='http://www.w3.org/2000/svg'><ellipse cx='105' cy='95' rx='92' ry='7' class='mm-spar__rg-mat'/><ellipse cx='62' cy='92' rx='24' ry='4.5' class='mm-spar__rg-sh'/><ellipse cx='148' cy='92' rx='24' ry='4.5' class='mm-spar__rg-sh'/><g class='mm-spar__rg-you'><g class='mm-spar__rg-bob'><path d='M54 84v-9M70 84v-9' class='limb you-s'/><path d='M62 46c-10 0-15 7-15 16v10c0 7 6 12 15 12s15-5 15-12V62c0-9-5-16-15-16z' class='fill-you'/><path d='M48 70h28' class='belt'/><circle cx='62' cy='34' r='14' class='fill-you-head'/><path d='M49 30a13 13 0 0 1 26 0c-4-4-8-2-13-5-3 4-9 2-13 5z' class='hair'/><circle cx='57' cy='35' r='1.9' class='ink'/><circle cx='68' cy='35' r='1.9' class='ink'/><path d='M58.5 40.5c1.6 1.6 4.4 1.6 6 0' class='smile'/><circle cx='47' cy='60' r='8' class='fill-glove-you'/><g class='mm-spar__rg-jab'><circle cx='80' cy='52' r='9' class='fill-glove-you'/><path d='M74 47.5c2-2 6-2 8 0' class='glove-line'/></g></g></g><g class='mm-spar__rg-riv'><g class='mm-spar__rg-bob mm-spar__rg-bob2'><path d='M156 84v-9M140 84v-9' class='limb rival-s'/><path d='M148 46c10 0 15 7 15 16v10c0 7-6 12-15 12s-15-5-15-12V62c0-9 5-16 15-16z' class='fill-rival'/><path d='M134 70h28' class='belt-r'/><circle cx='148' cy='34' r='14' class='fill-rival-head'/><g class='specs'><circle cx='143' cy='35' r='4.6'/><circle cx='154' cy='35' r='4.6'/><path d='M147.6 35h2.8'/></g><circle cx='143' cy='35' r='1.8' class='ink'/><circle cx='154' cy='35' r='1.8' class='ink'/><path d='M145 42c1.6-1.3 4.4-1.3 6 0' class='smile-r'/><circle cx='163' cy='60' r='8' class='fill-glove-rival'/><g class='mm-spar__rg-jabr'><circle cx='130' cy='52' r='9' class='fill-glove-rival'/><path d='M128 47.5c2-2 6-2 8 0' class='glove-line-r'/></g></g></g><g class='mm-spar__rg-spark mm-spar__rg-spark-r'><path d='M112 46l4-7 1.5 7.5 7-2-5 5.5 6 3.5-7.5.5 2 6.5-5.5-4.5-4 5 .5-7z'/></g><g class='mm-spar__rg-spark mm-spar__rg-spark-y'><path d='M98 46l-4-7-1.5 7.5-7-2 5 5.5-6 3.5 7.5.5-2 6.5 5.5-4.5 4 5-.5-7z'/></g></svg>";
  var ringBox = el('div', 'mm-spar__ringbox');
  ringBox.appendChild(ringEl);

  var rail = el('div', 'mm-spar__rail');
  var railSegs = [];
  for (var r = 0; r < ROUNDS; r++) { var sg = el('div', 'mm-spar__rail-seg'); rail.appendChild(sg); railSegs.push(sg); }
  var railLabel = el('div', 'mm-spar__rail-label', 'Estudio del rival');
  rail.appendChild(railLabel);
  headL.appendChild(rail);
  head.appendChild(headL);
  head.appendChild(ringBox);
  root.appendChild(head);

  /* Reacción de los boxeadores */
  var ringTimer = null;
  function ringReact(state) {
    if (reduced) return;
    ringEl.className = 'mm-spar__ring';
    void ringEl.offsetWidth;
    ringEl.classList.add(state);
    if (ringTimer) clearTimeout(ringTimer);
    ringTimer = setTimeout(function () { ringEl.classList.remove(state); }, state === 'is-cheer' ? 2400 : 1100);
  }

  /* Franja fija hacia Resúmenes MIR Activos, visible desde el principio */
  if (CFG.productUrl && CFG.topText) {
    var top = el('div', 'mm-spar__top');
    var topTx = el('div', 'mm-spar__top-text');
    var badgeTxt = CFG.topBadge || 'Resúmenes MIR Activos';
    try {
      if (CFG.examDate) {
        var ms = new Date(CFG.examDate + 'T09:00:00').getTime() - Date.now();
        var days = Math.ceil(ms / 86400000);
        if (days > 1) badgeTxt = 'Quedan ' + days + ' días para el MIR';
        else if (days === 1) badgeTxt = 'El MIR es mañana';
      }
    } catch (e) {}
    topTx.appendChild(el('span', 'mm-spar__top-badge', esc(badgeTxt)));
    topTx.appendChild(el('span', null, esc(CFG.topText)));
    top.appendChild(topTx);
    var topA = el('a', 'mm-spar__top-btn', '<span>' + esc(CFG.topButton) + '</span>');
    topA.href = CFG.productUrl;
    top.appendChild(topA);
    root.appendChild(top);
  }

  var stage = el('div', 'mm-spar__stage');
  root.appendChild(stage);
  var bell = el('div', 'mm-spar__bell');
  var bellIn = el('div', 'mm-spar__bell-in');
  bell.appendChild(bellIn);
  stage.appendChild(bell);

  var current = null;

  function updateRail() {
    var doneRounds = Math.floor(countAnswered() / ROUND);
    var inRound = countAnswered() % ROUND;
    for (var i = 0; i < ROUNDS; i++) {
      railSegs[i].className = 'mm-spar__rail-seg';
      if (i < doneRounds) railSegs[i].classList.add('is-done');
      else if (i === doneRounds && inRound > 0) { railSegs[i].classList.add('is-now'); imp(railSegs[i], '--mm-fill', String(inRound / ROUND)); }
    }
    if (S.phase === 'play') railLabel.textContent = 'Asalto ' + (Math.floor(S.idx / ROUND) + 1) + ' de ' + ROUNDS;
    else if (S.phase === 'round') railLabel.textContent = 'Fin del asalto ' + (Math.floor((S.idx - 1) / ROUND) + 1);
    else if (S.phase === 'final') railLabel.textContent = 'Combate terminado';
    else if (S.phase === 'cover') railLabel.textContent = ROUNDS + ' asaltos';
    else railLabel.textContent = 'Estudio del rival';
  }
  function countAnswered() { return Object.keys(S.results).length; }

  function show(screen) {
    var old = current;
    screen.classList.add('mm-spar__screen');
    stage.appendChild(screen);
    // forzar reflow antes de animar
    void screen.offsetWidth;
    screen.classList.add('is-on');
    if (old) {
      old.classList.remove('is-on');
      old.classList.add('is-out');
      setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, reduced ? 0 : 380);
    }
    current = screen;
    updateRail();
    // llevar la vista al inicio del widget si se ha quedado arriba
    try {
      var top = root.getBoundingClientRect().top;
      if (top < -10 || top > window.innerHeight * 0.6) root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {}
  }

  function ring(text) {
    bellIn.textContent = text;
    bell.classList.remove('is-ring');
    void bellIn.offsetWidth;
    bell.classList.add('is-ring');
  }

  /* ---------- iconos animados de los rasgos ---------- */
  var ICONS = {
    actual: '<svg viewBox="0 0 48 48" aria-hidden="true"><g class="mm-spar__ico-rot"><g transform="translate(4.8 4.8) scale(1.6)" stroke-width="1.5"><path d="M20.49 15A9 9 0 1 1 18.36 5.64L23 10"/><path d="M23 4v6h-6" class="acc"/></g></g><circle cx="24" cy="24" r="2.2" class="fill-acc"/></svg>',
    justo: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="14"/><path d="M24 11.5v2M36.5 24h-2M24 36.5v-2M11.5 24h2"/><path d="M24 24V15.5"/><g class="mm-spar__ico-min"><path d="M24 24l7 0" class="acc"/></g><circle cx="24" cy="24" r="1.8" class="fill-acc"/></svg>',
    proa: '<svg viewBox="0 0 48 48" aria-hidden="true"><g transform="rotate(-30 24 24)"><rect x="12" y="18.5" width="24" height="11" rx="5.5"/><path d="M24 18.5v11"/><path d="M14.5 24h9.5" class="soft"/></g><g class="mm-spar__ico-slash"><path d="M11 37L37 11" class="acc"/></g></svg>',
    inmuno: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="14" class="dash"/><circle cx="24" cy="24" r="7"/><circle cx="24" cy="24" r="2.5" class="fill-acc"/><g class="mm-spar__ico-orbit"><circle cx="38" cy="24" r="2.6" class="fill-p"/><circle cx="17" cy="36.1" r="2.6" class="fill-p"/><circle cx="17" cy="11.9" r="2.6" class="fill-acc"/></g></svg>',
    espana: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="21" r="6" class="mm-spar__ico-pulse acc"/><path d="M24 40s-11-10.5-11-19a11 11 0 0 1 22 0c0 8.5-11 19-11 19z"/><circle cx="24" cy="21" r="3.6" class="fill-acc"/></svg>',
    micro: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="15"/><circle cx="24" cy="24" r="11.5" class="soft"/><circle cx="19" cy="20" r="3" class="mm-spar__ico-col fill-acc"/><circle cx="29.5" cy="18.5" r="2.4" class="mm-spar__ico-col fill-p"/><circle cx="25.5" cy="29.5" r="3.4" class="mm-spar__ico-col fill-p"/></svg>'
  };
  function seal(traitKey, small) {
    var t = TR[traitKey];
    var s = el('span', 'mm-spar__ico mm-spar__ico--' + traitKey + (small ? ' mm-spar__ico--sm' : ''));
    s.innerHTML = (ICONS[traitKey] || '') + (small ? '<span class="mm-spar__ico-label">' + esc(t ? t.seal : '') + '</span>' : '');
    s.title = t ? t.name : '';
    return s;
  }

  /* ---------- PORTADA ---------- */
  function renderCover() {
    S.phase = 'cover';
    var sc = el('div');
    var paper = el('div', 'mm-spar__paper mm-spar__cover');
    paper.appendChild(el('div', 'mm-spar__cover-kicker', 'Sparring de ' + esc(CFG.subject) + ' para el ' + esc(CFG.exam)));
    paper.appendChild(el('h2', null, 'Entrena contra el que escribe la pregunta.'));
    paper.appendChild(el('p', null, K.length + ' conceptos con más papeletas de caer, elegidos mirando la asignatura como la mira el especialista que redacta el examen. Primero conoces al rival. Luego, ' + ROUNDS + ' asaltos de ' + ROUND + ' conceptos con corrección al momento.'));

    var facts = el('div', 'mm-spar__cover-facts');
    [K.length + ' conceptos', ROUNDS + ' asaltos de ' + ROUND, 'Corrección al momento', 'Sin registro'].forEach(function (f) {
      facts.appendChild(el('span', 'mm-spar__fact', esc(f)));
    });
    paper.appendChild(facts);

    var saved = load();
    if (saved) {
      var box = el('div', 'mm-spar__resume');
      var done = Object.keys(saved.results).length;
      box.appendChild(el('span', null, 'Tienes un entrenamiento a medias: ' + done + ' de ' + K.length + ' conceptos.'));
      var acts = el('div');
      acts.appendChild(btn('mm-spar__btn', 'Continuar', function () {
        S.results = saved.results; S.idx = Math.min(saved.idx, K.length - 1);
        if (done >= K.length) { renderFinal(); return; }
        S.idx = done; renderConcept(true);
      }));
      box.appendChild(acts);
      paper.appendChild(box);
    }

    var actions = el('div', 'mm-spar__cover-actions');
    actions.appendChild(btn('mm-spar__btn', 'Estudiar al rival', function () { S.introStep = 0; renderIntro(); }));
    actions.appendChild(btn('mm-spar__btn mm-spar__btn--ghost', 'Saltar al ring', function () { startPlay(true); }));
    paper.appendChild(actions);
    sc.appendChild(paper);
    show(sc);
  }

  /* ---------- ESTUDIO DEL RIVAL ---------- */
  function renderIntro() {
    S.phase = 'intro';
    var step = INTRO[S.introStep];
    var t = TR[step.trait];
    var sc = el('div');
    var box = el('div', 'mm-spar__dossier');
    box.appendChild(el('div', 'mm-spar__dossier-step', 'Estudio del rival, ' + (S.introStep + 1) + ' de ' + INTRO.length));

    var nextBtn = btn('mm-spar__btn', S.introStep === INTRO.length - 1 ? 'Ver la ficha completa' : 'Siguiente', function () {
      S.introStep++;
      if (S.introStep >= INTRO.length) renderLegend(); else renderIntro();
    });

    if (step.type === 'guess') {
      box.appendChild(el('h3', null, esc(step.question)));
      box.appendChild(el('p', 'mm-spar__dossier-lead', 'Piensa en quién redacta. Elige la que crees que escribiría.'));
      var pair = el('div', 'mm-spar__pair');
      var reveal = el('div', 'mm-spar__reveal');
      var picks = [];
      step.opts.forEach(function (o, i) {
        var p = btn('mm-spar__pick', o);
        p.addEventListener('click', function () {
          picks.forEach(function (x) { x.disabled = true; });
          picks.forEach(function (x, j) { x.classList.add(j === step.ok ? 'is-yes' : 'is-no'); });
          var sl = seal(step.trait); sl.classList.add('is-pop');
          reveal.appendChild(sl);
          var txt = el('div');
          txt.appendChild(el('div', 'mm-spar__reveal-name', esc(t.name)));
          var lead = i === step.ok ? 'Bien visto. ' : 'Casi. ';
          txt.appendChild(el('p', 'mm-spar__reveal-text', esc(lead + step.reveal)));
          txt.appendChild(el('p', 'mm-spar__reveal-text', esc(t.desc)));
          reveal.appendChild(txt);
          void reveal.offsetWidth;
          reveal.classList.add('is-in');
          acts.classList.add('is-in');
          imp(acts, 'opacity', '1'); imp(acts, 'pointer-events', 'auto');
        });
        picks.push(p);
        pair.appendChild(p);
      });
      box.appendChild(pair);
      box.appendChild(reveal);
      var acts = el('div', 'mm-spar__dossier-actions');
      imp(acts, 'opacity', '0'); imp(acts, 'pointer-events', 'none'); imp(acts, 'transition', 'opacity .3s');
      acts.appendChild(nextBtn);
      box.appendChild(acts);
    } else {
      box.appendChild(el('h3', null, esc(t.name)));
      var rv = el('div', 'mm-spar__reveal');
      var sl2 = seal(step.trait); sl2.classList.add('is-pop');
      rv.appendChild(sl2);
      var tx = el('div');
      tx.appendChild(el('span', 'mm-spar__proof', esc(step.proof)));
      tx.appendChild(el('p', 'mm-spar__reveal-text', esc(step.proofText)));
      tx.appendChild(el('p', 'mm-spar__reveal-text', esc(t.desc)));
      rv.appendChild(tx);
      box.appendChild(rv);
      setTimeout(function () { rv.classList.add('is-in'); }, 60);
      var acts2 = el('div', 'mm-spar__dossier-actions');
      acts2.appendChild(nextBtn);
      box.appendChild(acts2);
    }
    sc.appendChild(box);
    show(sc);
  }

  function renderLegend() {
    S.phase = 'legend';
    var sc = el('div');
    var box = el('div', 'mm-spar__dossier');
    box.appendChild(el('div', 'mm-spar__dossier-step', 'La ficha del rival'));
    box.appendChild(el('h3', null, 'Seis manías. Cada concepto del entrenamiento lleva el sello de la que lo explica.'));
    box.appendChild(el('p', 'mm-spar__dossier-lead', 'Cuando falles uno, mira el sello: te dice desde qué ángulo te ha entrado el golpe.'));
    var grid = el('div', 'mm-spar__legend');
    var items = [];
    Object.keys(TR).forEach(function (k) {
      var it = el('div', 'mm-spar__legend-item');
      it.appendChild(seal(k));
      var tx = el('div');
      tx.appendChild(el('div', 'mm-spar__legend-name', esc(TR[k].name)));
      tx.appendChild(el('div', 'mm-spar__legend-sub', esc(TR[k].desc.split('.')[0] + '.')));
      it.appendChild(tx);
      grid.appendChild(it);
      items.push(it);
    });
    box.appendChild(grid);
    var gap = el('div', 'mm-spar__gap');
    gap.appendChild(el('h4', null, esc(D.gap.title)));
    gap.appendChild(el('p', null, esc(D.gap.text)));
    box.appendChild(gap);
    var acts = el('div', 'mm-spar__dossier-actions');
    acts.appendChild(btn('mm-spar__btn', 'Subir al ring', function () { startPlay(false); }));
    box.appendChild(acts);
    sc.appendChild(box);
    show(sc);
    items.forEach(function (it, i) { setTimeout(function () { it.classList.add('is-in'); }, reduced ? 0 : 120 + i * 90); });
  }

  /* ---------- ENTRENAMIENTO ---------- */
  function startPlay(fresh) {
    if (fresh) { S.results = {}; S.idx = 0; clear(); }
    S.idx = countAnswered();
    if (S.idx >= K.length) { renderFinal(); return; }
    renderConcept(true);
  }

  var okTitles = ['Golpe limpio.', 'Bien visto.', 'Ese no te lo cuela.', 'Marcas tú.', 'Lo tenías.'];
  var badTitles = ['Te ha entrado ese golpe.', 'Ha marcado el rival.', 'Este se lo lleva él.', 'Apuntado para el repaso.'];

  function renderConcept(isRoundStart) {
    S.phase = 'play';
    S.answered = false;
    var c = K[S.idx];
    var roundNum = Math.floor(S.idx / ROUND) + 1;
    var posInRound = (S.idx % ROUND) + 1;
    var sc = el('div');
    var card = el('div', 'mm-spar__paper mm-spar__card is-enter');

    var meta = el('div', 'mm-spar__meta');
    meta.appendChild(el('span', 'mm-spar__count', 'Asalto ' + roundNum + ', concepto ' + posInRound + ' de ' + ROUND));
    meta.appendChild(el('span', 'mm-spar__block', esc(BL[c.block] || c.block)));
    card.appendChild(meta);
    card.appendChild(el('h3', 'mm-spar__concept-title', esc(c.title)));
    card.appendChild(el('div', 'mm-spar__fmt', fmtLabel(c.fmt)));

    var body = el('div');
    card.appendChild(body);

    var verdict = el('div', 'mm-spar__verdict');
    card.appendChild(verdict);
    var nextWrap = el('div', 'mm-spar__next');
    imp(nextWrap, 'display', 'none');
    card.appendChild(nextWrap);

    function settle(ok) {
      if (S.answered) return;
      S.answered = true;
      S.results[c.id] = ok;
      save();
      updateRail();
      ringReact(ok ? 'is-you-hit' : 'is-riv-hit');
      verdict.classList.add(ok ? 'is-ok' : 'is-bad');
      var st = el('span', 'mm-spar__stamp', ok ? 'Dominado' : 'A repasar');
      verdict.appendChild(st);
      var tx = el('div');
      tx.appendChild(el('div', 'mm-spar__verdict-title', esc(ok ? pick(okTitles) : pick(badTitles))));
      tx.appendChild(el('p', 'mm-spar__exp', c.exp));
      var why = el('div', 'mm-spar__why');
      why.appendChild(el('span', 'mm-spar__why-tag', 'Por qué lo preguntaría'));
      why.appendChild(seal(c.trait, true));
      why.appendChild(el('div', null, esc(c.why)));
      tx.appendChild(why);
      verdict.appendChild(tx);
      void verdict.offsetWidth;
      verdict.classList.add('is-in');
      var isLast = (S.idx % ROUND === ROUND - 1) || S.idx === K.length - 1;
      var nb = btn('mm-spar__btn' + (isLast ? ' mm-spar__btn--acc' : ''), isLast ? 'Cerrar el asalto' : 'Siguiente', function () {
        S.idx++;
        if (isLast) renderRoundEnd(); else renderConcept(false);
      });
      nextWrap.appendChild(nb);
      imp(nextWrap, 'display', 'flex');
    }

    /* --- formatos --- */
    if (c.fmt === 'vf') {
      body.appendChild(el('p', 'mm-spar__q', c.q));
      var vf = el('div', 'mm-spar__vf');
      [['Verdadero', true], ['Falso', false]].forEach(function (o) {
        var b = btn('mm-spar__opt', o[0]);
        b.addEventListener('click', function () {
          var all = vf.querySelectorAll('button');
          for (var i = 0; i < all.length; i++) all[i].disabled = true;
          var ok = (o[1] === c.ok);
          b.classList.add(ok ? 'is-ok' : 'is-bad');
          if (!ok) { for (var j = 0; j < all.length; j++) if (all[j] !== b) all[j].classList.add('is-ok'); }
          settle(ok);
        });
        vf.appendChild(b);
      });
      body.appendChild(vf);

    } else if (c.fmt === 'duelo' || c.fmt === 'caso' || c.fmt === 'antibiograma') {
      body.appendChild(el('p', 'mm-spar__q', c.q));
      if (c.fmt === 'antibiograma') {
        var wrap = el('div', 'mm-spar__abg');
        var html = '<table><thead><tr><th>Antibiótico</th><th>CMI (mg/L)</th><th>Interpretación</th></tr></thead><tbody>';
        c.rows.forEach(function (rw) {
          html += '<tr><td>' + esc(rw[0]) + '</td><td>' + esc(rw[1]) + '</td><td class="' + (rw[2] === 'S' ? 'is-s' : 'is-r') + '">' + esc(rw[2]) + '</td></tr>';
        });
        html += '</tbody></table>';
        wrap.innerHTML = html;
        body.appendChild(wrap);
      }
      var opts = el('div', 'mm-spar__opts' + (c.fmt === 'duelo' ? ' mm-spar__opts--duel' : ''));
      var buttons = [];
      shuffled(c.opts.length).forEach(function (i) {
        var b = btn('mm-spar__opt', c.opts[i]);
        b.addEventListener('click', function () {
          buttons.forEach(function (x) { x.disabled = true; });
          var ok = (i === c.ok);
          buttons.forEach(function (x, j) {
            if (j === c.ok) x.classList.add('is-ok');
            else if (j === i) x.classList.add('is-bad');
            else x.classList.add('is-dim');
          });
          settle(ok);
        });
        buttons[i] = b;
        opts.appendChild(b);
      });
      body.appendChild(opts);

    } else if (c.fmt === 'hueco') {
      var q = el('p', 'mm-spar__q');
      q.innerHTML = c.pre + ' <span class="mm-spar__blank">&nbsp;</span> ' + c.post;
      var blank = q.querySelector('.mm-spar__blank');
      body.appendChild(q);
      var chips = el('div', 'mm-spar__chips');
      var cb = [];
      shuffled(c.chips.length).forEach(function (i) {
        var ch = c.chips[i];
        var b = btn('mm-spar__chip', esc(ch));
        b.addEventListener('click', function () {
          cb.forEach(function (x) { x.disabled = true; });
          var ok = (i === c.ok);
          blank.textContent = c.chips[c.ok];
          blank.classList.add(ok ? 'is-ok' : 'is-bad');
          cb.forEach(function (x, j) {
            if (j === c.ok) x.classList.add('is-ok');
            else if (j === i) x.classList.add('is-bad');
            else x.classList.add('is-dim');
          });
          settle(ok);
        });
        cb[i] = b;
        chips.appendChild(b);
      });
      body.appendChild(chips);
    }

    sc.appendChild(card);
    show(sc);
    if (isRoundStart && S.idx % ROUND === 0) setTimeout(function () { ring('Asalto ' + roundNum); }, 120);
  }

  function fmtLabel(f) {
    return {
      vf: 'Verdadero o falso',
      duelo: 'Duelo: elige uno',
      caso: 'Caso: elige la actitud',
      hueco: 'Completa el hueco',
      antibiograma: 'Lee el antibiograma y decide'
    }[f] || '';
  }

  /* ---------- FIN DE ASALTO ---------- */
  function renderRoundEnd() {
    S.phase = 'round';
    var roundNum = Math.floor((S.idx - 1) / ROUND) + 1;
    var from = (roundNum - 1) * ROUND, to = Math.min(from + ROUND, K.length);
    var slice = K.slice(from, to);
    var okN = slice.filter(function (c) { return S.results[c.id] === true; }).length;
    var isFinalRound = to >= K.length;

    var sc = el('div');
    var paper = el('div', 'mm-spar__paper');
    paper.appendChild(el('h3', 'mm-spar__round-title', 'Fin del asalto ' + roundNum));
    paper.appendChild(el('p', 'mm-spar__round-sub', okN === slice.length ? 'Asalto limpio. Ninguno se le ha escapado al rival.' : okN >= slice.length * 0.7 ? 'Buen asalto. Los que te han entrado, abajo.' : 'Asalto duro. Estos son los conceptos que el rival ha marcado.'));

    var stamps = el('div', 'mm-spar__stamps');
    var stampEls = [];
    slice.forEach(function (c) {
      var ok = S.results[c.id] === true;
      var st = el('span', 'mm-spar__stamp ' + (ok ? 'is-ok' : 'is-bad'), ok ? 'Dominado' : 'A repasar');
      st.title = c.title;
      stamps.appendChild(st);
      stampEls.push(st);
    });
    paper.appendChild(stamps);

    var score = el('div', 'mm-spar__score');
    score.appendChild(el('span', 'mm-spar__score-big', String(okN)));
    score.appendChild(el('span', 'mm-spar__score-of', 'de ' + slice.length + ' dominados'));
    paper.appendChild(score);

    var missed = slice.filter(function (c) { return S.results[c.id] !== true; });
    var mbox = el('div', 'mm-spar__missed');
    mbox.appendChild(el('h4', null, 'Para volver a mirar'));
    if (missed.length) {
      var ul = el('ul');
      missed.forEach(function (c) {
        var li = el('li');
        li.appendChild(seal(c.trait, true));
        li.appendChild(el('span', null, esc(c.title)));
        ul.appendChild(li);
      });
      mbox.appendChild(ul);
    } else {
      mbox.appendChild(el('p', 'mm-spar__missed-empty', 'Nada. Siguiente asalto.'));
    }
    paper.appendChild(mbox);

    var acts = el('div', 'mm-spar__final-actions');
    acts.appendChild(btn('mm-spar__btn', isFinalRound ? 'Ver el marcador final' : 'Asalto ' + (roundNum + 1), function () {
      if (isFinalRound) renderFinal(); else renderConcept(true);
    }));
    paper.appendChild(acts);
    sc.appendChild(paper);
    show(sc);
    stampEls.forEach(function (st, i) { setTimeout(function () { st.classList.add('is-in'); }, reduced ? 0 : 200 + i * 110); });
    setTimeout(function () { ringReact(okN >= slice.length / 2 ? 'is-cheer' : 'is-riv-hit'); }, reduced ? 0 : 400);
  }

  /* ---------- MARCADOR FINAL ---------- */
  var traitHints = {
    actual: 'Repasa lo que ha cambiado en los dos últimos años: guías nuevas, fármacos nuevos y calendario vacunal. Es lo primero que el redactor quiere preguntar.',
    justo: 'Vuelve a lo de guardia: meningitis, sepsis, celulitis grave, empírico. Son las preguntas que considera obligatorias y las que menos perdona.',
    proa: 'Cuando dudes, la respuesta que más le gusta es no tratar, desescalar o pasar a oral. Revisa duraciones, bacteriuria y alergia a penicilina.',
    inmuno: 'Su consulta es el inmunodeprimido. Repasa oportunistas por CD4, neutropenia febril, hongos y profilaxis antes de inmunosuprimir.',
    espana: 'Las zoonosis españolas se le escapan a mucha gente. Brucella, Coxiella, Rickettsia, Leishmania, Nilo y Crimea-Congo, con su vector y su tratamiento.',
    micro: 'Entrena la lectura de antibiogramas y los mecanismos de resistencia. Y de cada prueba diagnóstica, aprende su limitación: es lo que pregunta.'
  };

  function renderFinal() {
    S.phase = 'final';
    save();
    var total = K.filter(function (c) { return S.results[c.id] === true; }).length;
    var sc = el('div');
    var paper = el('div', 'mm-spar__paper');
    imp(paper, 'position', 'relative');
    paper.appendChild(el('h3', 'mm-spar__round-title', 'Combate terminado'));
    paper.appendChild(el('p', 'mm-spar__round-sub', total >= 45 ? 'Al rival le va a costar pillarte en Infecciosas.' : total >= 35 ? 'Buen combate. Los conceptos de abajo son tu lista de repaso.' : 'Ahora ya sabes por dónde te entra. Eso es lo que vale de un sparring.'));

    var score = el('div', 'mm-spar__score');
    score.appendChild(el('span', 'mm-spar__score-big', String(total)));
    score.appendChild(el('span', 'mm-spar__score-of', 'de ' + K.length + ' dominados'));
    paper.appendChild(score);

    var grid = el('div', 'mm-spar__final-grid');
    var bars = [];

    // por asalto
    var p1 = el('div', 'mm-spar__panel');
    p1.appendChild(el('h4', null, 'Por asalto'));
    for (var r = 0; r < ROUNDS; r++) {
      var from = r * ROUND, to = Math.min(from + ROUND, K.length);
      var sl = K.slice(from, to);
      var okN = sl.filter(function (c) { return S.results[c.id] === true; }).length;
      p1.appendChild(barRow('Asalto ' + (r + 1), okN, sl.length, bars));
    }
    grid.appendChild(p1);

    // por bloque
    var p2 = el('div', 'mm-spar__panel');
    p2.appendChild(el('h4', null, 'Por bloque'));
    Object.keys(BL).forEach(function (bk) {
      var sl = K.filter(function (c) { return c.block === bk; });
      if (!sl.length) return;
      var okN = sl.filter(function (c) { return S.results[c.id] === true; }).length;
      p2.appendChild(barRow(BL[bk], okN, sl.length, bars));
    });
    grid.appendChild(p2);
    paper.appendChild(grid);

    // diagnóstico por rasgo
    var worst = null, worstFails = 0;
    Object.keys(TR).forEach(function (k) {
      var sl = K.filter(function (c) { return c.trait === k; });
      var fails = sl.filter(function (c) { return S.results[c.id] !== true; }).length;
      var rate = sl.length ? fails / sl.length : 0;
      if (fails >= 2 && (worst === null || rate > worst.rate)) { worst = { k: k, rate: rate, fails: fails, n: sl.length }; worstFails = fails; }
    });
    var diag = el('div', 'mm-spar__diag');
    if (worst) {
      diag.innerHTML = '<strong>Por dónde te entra el rival:</strong> ' + esc(TR[worst.k].name.toLowerCase()) + ' (' + worst.fails + ' de ' + worst.n + ' fallados). ' + esc(traitHints[worst.k]);
      diag.insertBefore(seal(worst.k, true), diag.firstChild);
    } else {
      diag.innerHTML = '<strong>Sin un ángulo débil claro.</strong> Ningún rasgo del rival te ha marcado dos veces. Repasa lo poco que se te ha escapado y a otra asignatura.';
    }
    paper.appendChild(diag);

    // lista de repaso
    var missed = K.filter(function (c) { return S.results[c.id] !== true; });
    var mbox = el('div', 'mm-spar__missed');
    mbox.appendChild(el('h4', null, missed.length ? 'Tu lista de repaso (' + missed.length + ')' : 'Lista de repaso'));
    if (missed.length) {
      var ul = el('ul');
      missed.forEach(function (c) {
        var li = el('li');
        li.appendChild(seal(c.trait, true));
        li.appendChild(el('span', null, esc(c.title)));
        ul.appendChild(li);
      });
      mbox.appendChild(ul);
      var row = el('div', 'mm-spar__copy-row');
      var copied = el('span', 'mm-spar__copied', 'Copiada');
      row.appendChild(btn('mm-spar__btn mm-spar__btn--ghost', 'Copiar la lista', function () {
        var txt = 'Sparring de ' + CFG.subject + ' (' + CFG.brand + ') - conceptos a repasar:\n' + missed.map(function (c) { return '- ' + c.title + ' [' + BL[c.block] + ']'; }).join('\n');
        copyText(txt, function () { copied.classList.add('is-in'); setTimeout(function () { copied.classList.remove('is-in'); }, 1800); });
      }));
      row.appendChild(copied);
      mbox.appendChild(row);
    } else {
      mbox.appendChild(el('p', 'mm-spar__missed-empty', 'Vacía. Los 50 dominados.'));
    }
    paper.appendChild(mbox);

    // Cierre hacia Resúmenes MIR Activos
    if (CFG.productUrl) {
      var promo = el('div', 'mm-spar__promo');
      var pg = el('div', 'mm-spar__promo-grid');
      var ptx = el('div', 'mm-spar__promo-text');
      ptx.appendChild(el('span', 'mm-spar__promo-kicker', 'Siguiente asalto'));
      ptx.appendChild(el('h4', null, 'Este Sparring era una asignatura. Resúmenes MIR Activos es todas.'));
      var lead = missed.length
        ? 'Los ' + missed.length + ' conceptos de tu lista de repaso están explicados en el resumen de ' + esc(CFG.subject) + ', cada uno con su cajita de recuerdo activo para que la próxima vez salgan de tu memoria y no de la página.'
        : 'Los ' + K.length + ' conceptos de este Sparring salen del resumen de ' + esc(CFG.subject) + '. Allí está el tema entero con sus cajitas de recuerdo activo, y el resto de asignaturas esperando su turno.';
      ptx.appendChild(el('p', null, lead));
      var pills = el('div', 'mm-spar__promo-pills');
      CFG.productPills.forEach(function (t) { pills.appendChild(el('span', 'mm-spar__promo-pill', esc(t))); });
      ptx.appendChild(pills);
      var pa = el('a', 'mm-spar__btn mm-spar__promo-btn', esc(CFG.productButton));
      pa.href = CFG.productUrl;
      ptx.appendChild(pa);
      ptx.appendChild(el('p', 'mm-spar__promo-foot', esc(CFG.productFoot)));
      pg.appendChild(ptx);

      // abanico de asignaturas: la actual sellada, las demás esperando
      var fan = el('div', 'mm-spar__fan');
      var fanCards = [];
      CFG.fanSubjects.forEach(function (name, i) {
        var fc = el('div', 'mm-spar__fan-card');
        var isThis = name === CFG.subject;
        fc.innerHTML = '<span class="mm-spar__fan-bar"></span><span class="mm-spar__fan-name">' + esc(name) + '</span><span class="mm-spar__fan-line"></span><span class="mm-spar__fan-line mm-spar__fan-line--s"></span><span class="mm-spar__fan-line"></span>';
        if (isThis) {
          var st = el('span', 'mm-spar__fan-stamp', total >= 40 ? 'Dominada' : 'En marcha');
          fc.appendChild(st);
          fc.classList.add('is-this');
        }
        imp(fc, '--mm-i', String(i));
        fan.appendChild(fc);
        fanCards.push(fc);
      });
      pg.appendChild(fan);
      promo.appendChild(pg);
      paper.appendChild(promo);
      setTimeout(function () { promo.classList.add('is-in'); fanCards.forEach(function (fc, i) { setTimeout(function () { fc.classList.add('is-in'); }, reduced ? 0 : 200 + i * 110); }); }, reduced ? 0 : 500);
    }
    // CTA correo
    if (CFG.emailUrl) {
      var cta2 = el('div', 'mm-spar__cta');
      cta2.appendChild(el('h4', null, esc(CFG.emailTitle)));
      cta2.appendChild(el('p', null, esc(CFG.emailText)));
      var a2 = el('a', 'mm-spar__btn', esc(CFG.emailButton));
      a2.href = CFG.emailUrl;
      cta2.appendChild(a2);
      paper.appendChild(cta2);
    }

    var acts = el('div', 'mm-spar__final-actions');
    acts.appendChild(btn('mm-spar__btn mm-spar__btn--ghost', 'Volver a entrenar desde cero', function () { S.results = {}; S.idx = 0; clear(); renderCover(); }));
    paper.appendChild(acts);

    sc.appendChild(paper);
    show(sc);
    bars.forEach(function (b, i) { setTimeout(function () { b.classList.add('is-in'); }, reduced ? 0 : 150 + i * 60); });
    setTimeout(function () { ringReact(total >= K.length / 2 ? 'is-cheer' : 'is-riv-hit'); }, reduced ? 0 : 350);
    if (!reduced && total >= 35) setTimeout(function () { confetti(paper); }, 250);
    clear(); // el combate terminado no se restaura
  }

  function barRow(label, okN, n, bars) {
    var row = el('div', 'mm-spar__bar-row');
    var left = el('div');
    left.appendChild(el('div', 'mm-spar__bar-label', esc(label)));
    var bar = el('div', 'mm-spar__bar');
    var fill = el('i');
    imp(fill, '--mm-fill', String(n ? okN / n : 0));
    bar.appendChild(fill);
    left.appendChild(bar);
    row.appendChild(left);
    row.appendChild(el('div', 'mm-spar__bar-num', okN + '/' + n));
    bars.push(fill);
    return row;
  }

  function copyText(txt, done) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done, function () { fallbackCopy(txt, done); });
    } else fallbackCopy(txt, done);
  }
  function fallbackCopy(txt, done) {
    try {
      var ta = document.createElement('textarea');
      ta.value = txt;
      imp(ta, 'position', 'fixed'); imp(ta, 'opacity', '0'); imp(ta, 'left', '-9999px');
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    } catch (e) {}
  }

  function confetti(host) {
    var box = el('div', 'mm-spar__confetti');
    var colors = ['#306086', '#6a93b3', '#d98c3f', '#2f9e5c', '#f3d9b9'];
    for (var i = 0; i < 46; i++) {
      var p = el('i');
      imp(p, 'left', (Math.random() * 100) + '%');
      imp(p, 'background', colors[i % colors.length]);
      imp(p, 'animation-delay', (Math.random() * 0.5) + 's');
      imp(p, 'animation-duration', (1.1 + Math.random() * 0.8) + 's');
      box.appendChild(p);
    }
    host.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 2600);
  }

  /* ---------- arranque ---------- */
  renderCover();

  // Exposición mínima por si hace falta desde fuera
  window.mirmedic_spar_restart = function () { S.results = {}; S.idx = 0; clear(); renderCover(); };
})();
